module.exports = __webpack_public_path__ + "static/media/grocery-finder.e32f1071.png";